<template>
  <div class="col-xl-12 col-lg-12 col-sm-12 col-md-12 mt-3">
    <generalForm typeForm="integer" :variableData="variableDataComponent">
      <template v-slot="{}">
        <b-tab id="obs1" title="Tipo de Campo" class="px-1">
          <ValidationObserver ref="obs1">
            <b-card class="card-form shadow">
              <div class="row">
                <div class="col-md-6 col-lg-4 col-sm-12">
                  <InputSelect
                    id="measure_unit"
                    name="measure_unit"
                    label="Unidad de Medida"
                    :options="measure_unit_options"
                    placeholder="Seleccione una unidad de medida"
                    :value.sync="variableDataComponent.config.unitMeasurement"
                  />
                </div>
                <div class="col-md-6 col-lg-4 col-sm-12">
                  <InputText
                    id="minimumValue"
                    name="minimumValue"
                    label="Valor Mínimo"
                    type="number"
                    validate="integer"
                    placeholder="Escriba el Mínimo"
                    :value.sync="variableDataComponent.config.minimumValue"
                  />
                </div>
                <div class="col-md-6 col-lg-4 col-sm-12">
                  <InputText
                    id="maximumValue"
                    name="maximumValue"
                    label="Valor Máximo"
                    type="number"
                    :validate="
                      `integer${
                        variableDataComponent.config.minimumValue !== null
                          ? '|minmax:' +
                            variableDataComponent.config.minimumValue +
                            ',9999999999'
                          : ''
                      }`
                    "
                    placeholder="Escriba el Máximo"
                    :value.sync="variableDataComponent.config.maximumValue"
                  />
                </div>
              </div>
            </b-card>
          </ValidationObserver>
        </b-tab>
      </template>
    </generalForm>
  </div>
</template>
<script>
import generalForm from '@/src/components/variables/general-form'
import InputText from '@components/form/InputText'
import InputSelect from '@components/form/InputSelect'
import { variablesMethods } from '@state/helpers'

export default {
  name: 'integerComponent',
  components: {
    generalForm,
    InputText,
    InputSelect,
  },
  props: {
    variableDataComponent: {
      type: Object,
      required: false,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      defaultConfig: {
        unitMeasurement: null,
        minimumValue: 0,
        maximumValue: null,
      },
      measure_unit_options: [],
    }
  },
  mounted() {
    this.getMeasureUnitsData()
    if (Object.keys(this.variableDataComponent.config).length === 0) {
      this.variableDataComponent.config = this.defaultConfig
    }
  },
  methods: {
    ...variablesMethods,

    getMeasureUnitsData() {
      const promise = this.getMeasureUnits()
      let _ = this
      return promise
        .then((data) => {
          data.results.forEach((opt) => {
            _.measure_unit_options.push({ value: opt.id, text: `${opt.name}` })
          })
          return data
        })
        .catch((error) => {
          console.log(
            'Se presento un error en la carga de las unidades de medida.',
            error
          )
        })
    },
  },
}
</script>
